module.exports = __webpack_public_path__ + "static/media/printlogo.46ac8381.jpg";